import { createApp } from 'vue'
import App from './App.vue'
import router from './router';
import { registerDevice } from './utilities/registerDevice.js'



const app = createApp(App)
app.use(router)
app.mount('#app')

registerDevice()

